module.exports = __webpack_public_path__ + "static/media/메세지 앱.7235de90.jpg";